import { gql } from '@apollo/client';

export const QUERY_FEATURE_CRITERIA = gql`
  query QUERY_FEATURE_CRITERIA {
    featureCriteria @client {
      viewFeature
      sortByFeature
      searchFeature
    }
  }
`;

export const MUTATION_UPDATE_FEATURE_VIEW = gql`
  mutation UpdateViewFeature($view: String!) {
    updateViewFeature(view: $view) @client
  }
`;

export const MUTATION_UPDATE_FEATURE_SORT_BY = gql`
  mutation UpdateSortByFeature($sortBy: String!) {
    updateSortByFeature(sortBy: $sortBy) @client
  }
`;

export const MUTATION_UPDATE_FEATURE_SEARCH = gql`
  mutation UpdateSearchFeature($search: String!) {
    updateSearchFeature(search: $search) @client
  }
`;

export const MUTATION_RESET_FEATURE_SEARCH = gql`
  mutation ResetSearchValuesFeature($view: String!) {
    resetSearchValuesFeature @client
  }
`;

export const MUTATION_UPDATE_FEATURE_FLAG = gql`
  mutation updateFeatureFlag($featureFlagId: Int!, $active: Boolean!, $featureName: String, $description: String) {
    AdminMutations {
      updateFeatureFlagById(
        featureFlagId: $featureFlagId
        active: $active
        featureName: $featureName
        description: $description
      ) {
        message
      }
    }
  }
`;

export const QUERY_FEATURE_ORG_CRITERIA = gql`
  query QUERY_FEATURE_CRITERIA {
    featureCriteria @client {
      viewFeature
      sortByFeature
      searchFeature
    }
  }
`;

export const MUTATION_UPDATE_FEATURE_ORG_VIEW = gql`
  mutation UpdateViewFeatureOrg($view: String!) {
    updateViewFeatureOrg(view: $view) @client
  }
`;

export const MUTATION_UPDATE_FEATURE_ORG_SORT_BY = gql`
  mutation UpdateSortByFeatureOrg($sortBy: String!) {
    updateSortByFeatureOrg(sortBy: $sortBy) @client
  }
`;

export const MUTATION_UPDATE_FEATURE_ORG_SEARCH = gql`
  mutation UpdateSearchFeatureOrg($search: String!) {
    updateSearchFeatureOrg(search: $search) @client
  }
`;

export const MUTATION_RESET_FEATURE_ORG_SEARCH = gql`
  mutation ResetSearchValuesFeatureOrg($view: String!) {
    resetSearchValuesFeatureOrg @client
  }
`;

export const MUTATION_ACTIVATE_FEATURE_FLAG_MAPPING = gql`
  mutation activateFeatureFlag($organizationId: Int!, $featureFlagId: Int!, $active: Boolean!) {
    AdminMutations {
      activateFeatureFlag(organizationId: $organizationId, featureFlagId: $featureFlagId, active: $active) {
        message
      }
    }
  }
`;
